import React from 'react'

const Jobs = () => {
  return (
    <div className="container">Jobs</div>
  )
}

export default Jobs